import {
  Questionnaire as IcbtQuestionnaire,
  type QuestionnaireVariant,
} from "@mindlercare/icbt";
import {
  useGetQuestionnaireContentQuery,
  useGetUserAnswersQuery,
} from "api/useQuestionnaireQueries";

type Props = {
  clinicalId?: string;
  requestId?: string;
  patientUserId?: number;
  questionnaireType: "clinical" | "icbt";
  variant?: QuestionnaireVariant;
};

export const Questionnaire = ({
  clinicalId,
  requestId,
  patientUserId,
  questionnaireType,
  variant,
}: Props) => {
  const { data: content, isFetching: isLoading } =
    useGetQuestionnaireContentQuery(clinicalId);

  const { data: answers } = useGetUserAnswersQuery({
    userId: patientUserId?.toString(),
    requestId,
    answerRequestType: questionnaireType,
  });

  return (
    <IcbtQuestionnaire
      content={content}
      answers={answers}
      requestId={requestId}
      isLoading={isLoading}
      variant={variant}
    />
  );
};
